export function contactBar() {
	$('.contact_cta_toggle').on('click', function (e) {
		e.preventDefault();

		const $this = $('#contact_cta_wrapper');

		if ($this.hasClass('active')) {
			$this.removeClass('active');
			$this.slideUp(200);
		} else {
			$this.addClass('active');
			$this.slideDown(200, function () {
				ctaSlideAdjust();
			});
		}
	});
}

function ctaSlideAdjust() {
	// CHECK THE WHOLE FORM IS VISIBLE
	const ctaForm = $('#contact_cta_marker');
	const formTop = ctaForm.offset().top;
	const formBottom = formTop + ctaForm.outerHeight();
	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	if (formBottom > viewportTop && formTop < viewportBottom) {
		// DO NOTHING
	} else {
		$('html, body').animate(
			{
				scrollTop: viewportTop + (formBottom - viewportBottom),
			},
			200
		);
	}
}
